"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
var _Text = _interopRequireDefault(require("../Text"));
var _react2 = require("motion/react");
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/** @jsxImportSource @emotion/react */

const InfoButton = ({
  trackingName,
  icon,
  place = 'top',
  children,
  stopPropagation,
  'aria-label': ariaLabel,
  width,
  className
}) => {
  const ref = /*#__PURE__*/(0, _react.createRef)();
  const [showTooltip, setShowTooltip] = (0, _react.useState)(false);
  const handleClick = e => {
    stopPropagation && e.stopPropagation();
    setShowTooltip(!showTooltip);
  };
  (0, _react.useEffect)(() => {
    const handleClickOutside = e => {
      const node = ref.current;
      if (node && node.contains(e.target)) {
        return;
      }
      setShowTooltip(false);
    };
    if (showTooltip) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showTooltip, ref]);
  return (0, _jsxRuntime.jsxs)(_styles.Wrapper, {
    ref: ref,
    className: className,
    children: [(0, _jsxRuntime.jsx)(_styles.StyledButton, {
      "aria-label": ariaLabel,
      trackingName: trackingName,
      nostyle: true,
      onClick: handleClick,
      children: icon ? icon : ''
    }), (0, _jsxRuntime.jsx)(_react2.AnimatePresence, {
      children: showTooltip && (0, _jsxRuntime.jsx)(_styles.Tooltip, {
        initial: {
          opacity: 0,
          scale: 0.9
        },
        animate: {
          opacity: 1,
          scale: 1
        },
        exit: {
          opacity: 0,
          scale: 0.9
        },
        transition: {
          duration: 0.1
        },
        role: "tooltip",
        id: "info-tooltip",
        "aria-hidden": !showTooltip,
        css: () => [_styles.styles.default, place === 'top' && _styles.styles.top, place === 'right' && _styles.styles.right, place === 'bottom' && _styles.styles.bottom, place === 'left' && _styles.styles.left, width && _styles.styles.width(width, place)],
        children: (0, _jsxRuntime.jsx)(_Text.default, {
          children: children ? children : ''
        })
      })
    })]
  });
};
var _default = exports.default = InfoButton;